import { TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledStorageTitle = styled.div`
  margin-top: 8px;
  padding: 2px;
  font-weight: bold;
`;

export const StyledStorageValue = styled.div`
  margin-top: 2px;
  padding: 2px;
`;

export const StyledAssetCount = styled.div`
  margin-top: 2px;
  padding: 2px;
  font-size: 0.85em;
  opacity: 0.7;
`;

export const StorageData = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
